<template>
  <el-header class="header">
    <h3>管理系统</h3>
    <span class="Breadcrumb">
      <Breadcrumb />
    </span>
    <div class="userInfo">
      <!-- 登录人头像 -->
      <el-dropdown>
        <span class="el-dropdown-link">
          <img class="avatar"  src="../assets/img/avatar.png" />
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <router-link to="/home/userInfo" class="go-userinfo">
              <el-dropdown-item>个人中心</el-dropdown-item>
            </router-link>
            <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script setup>
import Breadcrumb from '@/components/Breadcrumb'
import { ref } from 'vue'
import { useStore } from 'vuex'
const stroe = useStore()
const isShow = ref(false)
// eslint-disable-next-line
const searchVal = ref('')

// 退出登录
const logout = () => {
  stroe.dispatch('user/logout')
}
// 搜索方法
// eslint-disable-next-line
const search = () => {
  isShow.value = !isShow.value
}
// 搜索
// eslint-disable-next-line
const handleSelect = () => {}
// 全局搜索方法
// eslint-disable-next-line
const querySearch = () => {}
</script>

<style lang="less" scoped>
.avatar{
  width: 40px;
  border-radius: 50%;
}
.header {
  background: #38485c;
  line-height: 60px;
  color: #fff;
  font-size: 20px;
  width: 100vw;
  h3 {
    display: inline-block;
    line-height: 60px;
  }
  .Breadcrumb {
    position: absolute;
    display: inline-block;
    margin-left: 30px;
    line-height: 60px;
  }
  .userInfo {
    float: right;
    padding-top: 5px;
    .icons {
      margin: 0 10px;
      cursor: pointer;
      .search {
        transition: 0.3s;
        margin-left: 10px;
        ::v-deep .el-input__inner {
          transition: 0.3s;
          width: 200px;
        }
      }
    }
  }
}
.go-userinfo{

 text-decoration: none;
}
</style>>
